const isHomeRoute = (state) => {
  const currentPathname = String(state?.router?.location?.pathname || '').replace(/\/+$/, '') || '/';
  return currentPathname === '/';
};

export default isHomeRoute;
